module.exports = __webpack_public_path__ + "img/teacher-lesson-2-vi-VN.9c2fc51f.png";